import { Component, Inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { SidebarPanelComponent } from '../../sidebar/sidebar-panel/sidebar-panel.component';
import { AppMessageService } from '../../shared/app-message/app-message.service';
import { SidebarPanelParams, ELEMENT_PARAMETERS, ELEMENT_STATE_NAME, LandingPageTile } from '../../shared/tiles/home-tile.model';
import { _ } from '../../shared/utils';
import { StateService } from '../../shared/state/state.service';
import { GeometryObject } from 'geojson';
import { MapElement } from '../../shared/map/map-element.model';
import { SidebarService } from '../../shared/sidebar/sidebar.service';
import { MapService } from '../../shared/map/map.service';
import { VRGroupService } from '../../custom/vrgroup/vrgroup.service';
import { TrainInfoComponent } from '~app/custom/vrgroup/train-info/train-info/train-info.component';
import { ElementDetailsComponent } from '~app/element-details/element-details/element-details.component';
import { StationInfoComponent } from '~app/custom/vrgroup/station-info/station-info/station-info.component';

@Component({
  selector: 'qm-element-info',
  templateUrl: './element-info.component.html',
  styleUrls: ['./element-info.component.scss']
})
export class ElementInfoComponent extends SidebarPanelComponent implements OnInit {
  @ViewChild('inner')
  private inner: ElementDetailsComponent | TrainInfoComponent | StationInfoComponent;

  public currentFeature: MapElement<GeometryObject>;

  constructor(
    protected appMessageService: AppMessageService,
    protected sidebarService: SidebarService,
    private stateService: StateService,
    private mapService: MapService,
    private vrGroupService: VRGroupService,
    @Inject(ELEMENT_STATE_NAME) private elementName: string,
    @Inject(ELEMENT_PARAMETERS) public params: SidebarPanelParams
  ) {
    super(appMessageService, sidebarService);
    this.componentName = ElementInfoComponent.getComponentName();
    console.log(this.elementName);
  }

  public static initTile(tile: LandingPageTile) {
    tile.description = _('Element information');
    tile.icon = 'far fa-sticky-note';
    tile.title = _('Element information');
    tile.panel = ElementInfoComponent.getComponentName();
  }

  public static getComponentName(): string {
    return 'ElementInfo';
  }

  async ngOnInit() {
    if (this.params?.feature) {
      this.currentFeature = this.params.feature;
    } else { // If feature wasn't provided, search it (saved state);
      const featureId = this.stateService.getPartOfState(this.elementName);
      this.currentFeature = this.mapService.getFeatureById(featureId)
        || await this.vrGroupService.getTrainMapElementById(featureId);
    }
  }

  ngAfterViewInit() {
    this.refreshTitle();
  }

  public getTitle() {
    try {
      return this.currentFeature.properties[this.currentFeature.layer.metadata.labelBy];
    } catch (error) {
      return '';
    }
  }

  public refreshTitle() {
    const template = (this.inner && 'titleTemplate' in this.inner) ? this.inner.titleTemplate : null;
    this.emitTitleChange(this.getTitle(), template, this.elementName);
  }
}
